import React, { useContext, useEffect } from "react";

import { corewellAccordionItemOverrideClass, heroType } from "../../../constants/constants";
import { UiStateContext } from "../../contexts/ui-state/UiStateContext";
import {
  BackgroundMediaHeroContent,
  BreadcrumbsContent,
  FeatureToggle,
  HighImpactContainerHeroContent,
  IconPack,
  InsetHeadlineHeroContent,
  LowImpactNarrowHeroContent,
  MediumImpactContainerHeroContent,
  TransactionalHeroContent,
  ReferenceLinkContent
} from "../../models/app-data-model";
import HeroBackgroundMedia from "../heroes/background-media/background-media";
import HighImpactFullBleedHero from "../heroes/high-impact-full-bleed-hero/high-impact-full-bleed-hero";
import TransactionalHero from "../heroes/transactional-hero/transactional-hero";
import HighImpactReducedHeightHero from "../heroes/high-impact-reduced-height-hero/high-impact-reduced-height-hero";
import InsetHeadlineHero from "../heroes/inset-headline-hero/inset-headline-hero";
import HeroLowImpactNarrow from "../heroes/low-impact-narrow/low-impact-narrow";
import HeroMediumImpactContainer from "../heroes/medium-impact-container/medium-impact-container";
import KyruusEmbeddedSearch from "../kyruus-embedded-search/kyruus-embedded-search";
import { KyruusEmbeddedSearchContent } from "../kyruus-embedded-search/kyruus-embedded-search-model";

export type HeroContentProps = {
  content: ReferenceLinkContent[];
  breadcrumbs?: BreadcrumbsContent;
  featureToggles: FeatureToggle[];
  iconPack: IconPack[];
  subsiteNavPresent: boolean;
  headerPresent?: boolean;
  corewellStyleOverrides?: boolean;
};

const HeroWrapper: React.FC<HeroContentProps> = ({
  content,
  breadcrumbs,
  iconPack,
  featureToggles,
  subsiteNavPresent,
  headerPresent,
  corewellStyleOverrides
}: HeroContentProps) => {
  const type = content && content[0]?.internal?.type;
  const heroContent:
    | LowImpactNarrowHeroContent
    | MediumImpactContainerHeroContent
    | BackgroundMediaHeroContent
    | InsetHeadlineHeroContent
    | HighImpactContainerHeroContent
    | TransactionalHeroContent
    | KyruusEmbeddedSearchContent = {
    ...content[0],
    breadcrumbs: {
      title: breadcrumbs?.title || "",
      subsite: breadcrumbs?.subsite,
      hide_breadcrumbs: breadcrumbs?.hide_breadcrumbs
    }
  };

  const rendering = (
    <>
      {type === heroType.low && (
        <HeroLowImpactNarrow heroContent={heroContent as LowImpactNarrowHeroContent} corewellStyleOverrides={corewellStyleOverrides} />
      )}
      {type === heroType.medium && (
        <HeroMediumImpactContainer
          iconPack={iconPack}
          heroContent={heroContent as MediumImpactContainerHeroContent}
          corewellStyleOverrides={corewellStyleOverrides}
        />
      )}
      {type === heroType.high && (
        <HighImpactFullBleedHero
          iconPack={iconPack}
          content={heroContent as HighImpactContainerHeroContent}
          subsiteNavPresent={subsiteNavPresent}
          headerPresent={headerPresent}
          corewellStyleOverrides={corewellStyleOverrides}
        />
      )}
      {type === heroType.transactional && (
        <TransactionalHero
          content={heroContent as TransactionalHeroContent}
          subsiteNavPresent={subsiteNavPresent}
          headerPresent={headerPresent}
          iconPack={iconPack}
          featureToggles={featureToggles}
        />
      )}
      {type === heroType.media && (
        <HeroBackgroundMedia iconPack={iconPack} heroContent={heroContent as BackgroundMediaHeroContent} featureToggles={featureToggles} />
      )}
      {type === heroType.inset && (
        <InsetHeadlineHero heroContent={heroContent as InsetHeadlineHeroContent} featureToggles={featureToggles} />
      )}
      {type === heroType.reducedHeight && (
        <HighImpactReducedHeightHero
          iconPack={iconPack}
          content={heroContent as HighImpactContainerHeroContent}
          headerPresent={headerPresent}
          corewellStyleOverrides={corewellStyleOverrides}
        />
      )}
      {type === heroType.kyruusSearch && <KyruusEmbeddedSearch content={heroContent as KyruusEmbeddedSearchContent} />}
    </>
  );

  return rendering;
};

export default HeroWrapper;
